import { Stack } from "@mui/material"
import { ChangeTypeIcon } from "./change-type-icon"

const TASK_EDIT_TYPES = new Set(["schedule_title", "task_content", "task_title"])
const TASK_FREQUENCY_TYPES = new Set(["task_frequency"])
const TASK_NOTE_TYPES = new Set(["task_note"])

export function ChangeTypeSummaryIcons({ changes, minWidth = 136 }) {
    const list = Array.isArray(changes) ? changes : []
    const hasIntroEdit = list.some(isIntroductionEditChange)
    const hasIntroNote = list.some(isIntroductionNoteChange)
    const hasTaskEdit = list.some(isTaskEditChange)
    const hasTaskFrequency = list.some(isTaskFrequencyChange)
    const hasTaskNote = list.some(isTaskNoteChange)
    const hasNewTask = list.some(isTaskAddedChange)
    const hasRemovedTask = list.some(isTaskRemovedChange)

    return (
        <Stack direction="row" spacing={0.5} alignItems="center" sx={{ minWidth }}>
            <ChangeTypeIcon
                show={hasIntroEdit}
                icon="mdi:book-open-variant"
                color="primary.main"
                title="Introduction edited"
            />
            <ChangeTypeIcon
                show={hasIntroNote}
                icon="mdi:book-open-page-variant-outline"
                color="secondary.main"
                title="Introduction note edited"
            />
            <ChangeTypeIcon
                show={hasTaskEdit}
                icon="mdi:text-box-edit-outline"
                color="primary.main"
                title="Has task or title edits"
            />
            <ChangeTypeIcon
                show={hasTaskFrequency}
                icon="mdi:calendar-edit-outline"
                color="warning.main"
                title="Has task frequency updates"
            />
            <ChangeTypeIcon
                show={hasTaskNote}
                icon="mdi:note-edit-outline"
                color="secondary.main"
                title="Has task note updates"
            />
            <ChangeTypeIcon
                show={hasNewTask}
                icon="mdi:plus-circle-outline"
                color="success.main"
                title="Has new tasks"
            />
            <ChangeTypeIcon
                show={hasRemovedTask}
                icon="mdi:delete-outline"
                color="error.main"
                title="Has removed tasks"
            />
        </Stack>
    )
}

function isIntroductionEditChange(change) {
    return change?.changeType === "intro_content"
}

function isIntroductionNoteChange(change) {
    return change?.changeType === "intro_note"
}

function isTaskEditChange(change) {
    return TASK_EDIT_TYPES.has(change?.changeType)
}

function isTaskNoteChange(change) {
    return TASK_NOTE_TYPES.has(change?.changeType)
}

function isTaskFrequencyChange(change) {
    return TASK_FREQUENCY_TYPES.has(change?.changeType)
}

function isTaskAddedChange(change) {
    return change?.changeType === "add_task"
}

function isTaskRemovedChange(change) {
    return change?.changeType === "remove_task"
}
